import { FC } from 'react';

import { phoneNumberStringFormator } from '@shared/utils/phoneNumberStringFormator';
import { UseFormRegister } from 'react-hook-form';

import { TextField, TextFieldProps } from './TextField';

interface IProps extends TextFieldProps {
  value: string;
  register: UseFormRegister<any>;
  name: string;
  className?: string;
  required?: boolean;
}

const TelField: FC<IProps> = ({
  value,
  register,
  name,
  className,
  required,
  placeholder = '휴대전화번호',
  ...props
}: IProps) => {
  return (
    <TextField
      type="tel"
      className={className}
      placeholder={placeholder}
      value={phoneNumberStringFormator(value)}
      maxLength={13}
      {...register(name, {
        required,
        validate: (v: string) => {
          const onlyNum = v.replace(/[^0-9]/gi, '');
          // 010만 입력된 경우 허용
          if (onlyNum === '010' || onlyNum === '') return true;
          // 일반적인 휴대폰 번호 형식 검증 (10-11자리)
          if (onlyNum.length >= 10 && onlyNum.length <= 11) return true;
          return '올바른 휴대폰 번호를 입력해주세요';
        },
        setValueAs: (value) => value.replace(/[^0-9]/gi, ''),
      })}
      {...props}
    />
  );
};

export default TelField;
